import {
	request1,
	request2
} from './request.js'
import { isNumberBrowser } from "@/common/utils.js";
// 引入vuex
import store from '../store/index'

// 登录
export function logIn(account, password,code) {
	let params = new URLSearchParams();
	params.append('grant_type', 'huihang_adminpassword');
	params.append('client_id', 'huihang-admin');
	params.append('client_secret', 'zsb.web.secret');
	params.append('loginName', account);
	params.append('loginPwd', password);
	params.append('code', code);
	return request1({
		url: '/api1/connect/token',
		method: 'post',
		data: params
	})
}
// 登录
export function logIn1(grantType, client_id, client_secret, adminId) {
	let params = new URLSearchParams();
	params.append('grant_type', grantType);
	params.append('client_id', client_id);
	params.append('client_secret', client_secret);
	params.append('adminId', adminId);
	return request1({
		url: '/api1/connect/token',
		method: 'post',
		data: params
	})
}
// 获取管理员用户信息/TZsbAdminApi/Admin/LoginRoleInformation
export function loginRoleInformation() {
	return request2({
		url: '/api2/TZsbAdminApi/Admin/LoginRoleInformationNew?a=' + Math.random(),
		method: 'get',
	})
}
// 获取默认菜单
export function GetTheMenuById() {
	return request2({
		url: '/api7/SBCenterAdminApi/TheMenu/GetAuthorizeTheMenu' ,
		method: 'get',
	})
}
// 未登录前 登陆获取配置信息
export function ApolloConfigForWeb() {
	return request1({
		url: '/api2/AdminService/ApolloConfigForWeb',
		method: 'get',
	})
}

// 存储登录信息
export async function saveloginInfo(token, userInfo, allConfig) {
	// 存储token
	store.commit('saveTokenStorage', token);
	store.commit('saveUserInfoStorage', userInfo);
	store.commit('saveAllConfigStorage', allConfig);

	// //存储token
	sessionStorage.setItem('token', JSON.stringify(token))
	// //存储AdminCache
	sessionStorage.setItem("AdminCache", JSON.stringify(userInfo));


}
export async function loginUserInfo(userInfo){
	store.commit('saveUserInfoStorage', userInfo);
	sessionStorage.setItem("AdminCache", JSON.stringify(userInfo));
}


// 退出登录
export function logOut() {
	store.commit('changeLoginState', false);
	store.commit('saveTokenStorage', '');
	store.commit('saveUserInfoStorage', '');
	sessionStorage.removeItem('isLogin');
	sessionStorage.removeItem('store')
	sessionStorage.removeItem('token')
	sessionStorage.removeItem('AdminCache');
	sessionStorage.removeItem('themeStyle');
	// 登陆了指定管理员账号，会在地址栏留下参数，重新登陆账号会导致登录到上一个人账号，这里在退出登录的时候清除地址栏参数，重置登录
	var url = window.location.href; //获取当前页面的url
	var needReload = false; // 标记是否需要刷新
	
	if (url.indexOf("?") != -1) { //判断是否存在参数
		url = url.replace(/(\?|#)[^'"]*/, ''); //去除参数
		window.history.pushState({}, 0, url);
		needReload = true;
	}
	
	if (url.indexOf("/EarningReport") != -1) { //判断是否是业绩排行报表
		url = url.split('/EarningReport')[0]
		window.history.pushState({}, 0, url);
		needReload = true;
	}
	
	// 确保退出登录后总是刷新页面，以触发登录页的提示框
	window.location.reload();
		// 退出登录升本中心
      const defaultUrl = 'https://sb.hbzsb.cn/';
      let sessionCache = null;
      sessionCache = JSON.parse(sessionStorage.getItem('AdminCache'));
      const rawUrl = sessionCache?.centerAdminUrl || defaultUrl;
      const centerAdminUrl = rawUrl?.trim() || defaultUrl;
      sessionStorage.clear();
      const logoutUrl = `${centerAdminUrl}?logOut=true`;
      window.location.replace(logoutUrl);
}
// 通过手机号获取验证码
export function GetCodeByTelPhone(telPhone) {
	return request1({
		url: '/api2/AdminService/GetCodeByTelPhone',
		method: 'post',
		params: {
			telPhone: telPhone,
		}
	})
}
// 通过手机号获取管理员信息
export function GetAdminListForWeb(telPhone) {
	return request1({
		url: '/api2/AdminService/GetAdminListForWeb',
		method: 'post',
		params: {
			telPhone: telPhone,
		}
	})
}

// 重置密码
export function ResetPassword(obj) {
	return request1({
		url: '/api2/AdminService/ResetPassword',
		method: 'post',
		data: {
			telPhone: obj.telPhone,
			id: obj.id,
			passWord: obj.passWord,
			code: obj.code
		}
	})
}
// 获取后台项目的配置信息
export async function getApolloConfig() {
	let dataObject = {}
	//判断当前页面前缀是http还是https
	const ishttps = document.location.protocol == 'http:' ? true : false
	const result = await ApolloConfigForWeb();
	if (result && result.data.code == 1) {
		dataObject = result.data.result
		// 前台域名 
		let mobileAdressBefore = result.data.result.mobileAdress;
		// 判断域名地址最后一段是否存在'/'
		mobileAdressBefore.charAt(mobileAdressBefore.length - 1) == '/' ? dataObject.mobileAdress = mobileAdressBefore.substring(0, mobileAdressBefore.length - 1) : dataObject.mobileAdress = mobileAdressBefore
		// 前台电脑端域名
		let pcSiteUrlBefore = result.data.result.pcSiteUrl;
		// 判断域名地址最后一段是否存在'/'
		pcSiteUrlBefore.charAt(pcSiteUrlBefore.length - 1) == '/' ? dataObject.pcSiteUrl = pcSiteUrlBefore.substring(0, pcSiteUrlBefore.length - 1) : dataObject.pcSiteUrl = pcSiteUrlBefore
		// 用户中心域名
		let studentAddressBefore = result.data.result.studentAddress;
		// 判断域名地址最后一段是否存在'/'
		studentAddressBefore.charAt(studentAddressBefore.length - 1) == '/' ? dataObject.studentAddress = studentAddressBefore.substring(0, studentAddressBefore.length - 1) : dataObject.studentAddress = studentAddressBefore
		// 判断当前域名是否http:开头
		ishttps ? dataObject.mobileAdress = dataObject.mobileAdress.replace(/https:/, "http:") : dataObject.mobileAdress
		ishttps ? dataObject.pcSiteUrl = dataObject.pcSiteUrl.replace(/https:/, "http:") : dataObject.pcSiteUrl
		ishttps ? dataObject.studentAddress = dataObject.studentAddress.replace(/https:/, "http:") : dataObject.studentAddress
	}
	return dataObject
}
// 基于老师登录账号获取手机短信验证码
export function SendMsgTelResponseTo(account) {
	return request1({
		url: '/api2/AdminService/SendMsgTelResponseTo',
		method: 'post',
		params: {
			userName: account,
		}
	})
}
// 基于老师登录账号来判断用户是否同一Ip且在有效时间范围内的登陆
export function IsReLoginFromUserName(data) {
	// 用户浏览器名称 只返回360 其他为空
	let name = isNumberBrowser()
	
	return request1({
		url: '/api2/AdminService/IsReLoginFromUserName',
		method: 'get',
		params: {
			userName: data,
			userAgent: name
		}
	})
}

// 钉钉扫码授权登录
export function GetDingTalkCode(data) {
	return request1({
		url: '/api2/TZsbWebAdminApi/DingTalkWeb/GetDingTalkCode',
		method: 'get',
		params: data
	})
}
// 获取钉钉列表管理
export function GetAdminList(data) {
	return request1({
		url: '/api2/TZsbWebAdminApi/DingTalkWeb/GetAdminList',
		method: 'get',
		params: data
	})
}
// 钉钉登录
export function DingLogin(data) {
	return request1({
		url: '/api2/TZsbWebAdminApi/DingTalkWeb/Login',
		method: 'post',
		params: data
	})
}
// 通过userdingid获取管理员列表
export function GetAdminListById(userdingid) {
	return request1({
		url: '/api2/TZsbWebAdminApi/DingTalkWeb/GetAdminListById',
		method: 'get',
		params: {
			userdingid: userdingid
		}
	})
}

export function GetAdminLoginToken(data) {
	return request1({
		url: '/api7/SBCenterWebApi/AdminLogin/GetAdminLoginToken',
		method: 'get',
		params: data,
	})
}